<div class="pe-5" *ngIf="solution && solution.plannings && dateOfStart">
	<div class="row">
		<div class="col dropdown">
			<span
				class="theme-main-color"
				role="button"
				id="dropdownDayTypeList"
				data-bs-toggle="dropdown"
				aria-expanded="false"
			>
				Vue par :
				<span class="fw-bold">{{ isViewByDay ? 'Jour' : 'Semaine' }} </span>
				<i class="bi bi-chevron-down" aria-hidden="true"></i>
			</span>

			<ul
				class="dropdown-menu hand-cursor"
				aria-labelledby="dropdownDayTypeList"
			>
				<li (click)="changeDayType(false)">
					<a class="dropdown-item theme-main-color">Semaine</a>
				</li>
				<li (click)="changeDayType(true)">
					<a class="dropdown-item theme-main-color">Jour</a>
				</li>
			</ul>
		</div>

		<!-- CHOIX DU TYPE D'AFFICHAGE : BENEFICIAIRE OU INTERVENANT-->
		<div class="col dropdown" *ngIf="!isViewByDay">
			<span
				class="theme-main-color"
				role="button"
				id="dropdownViewListingType"
				data-bs-toggle="dropdown"
				aria-expanded="false"
			>
				Afficher par :
				<span class="fw-bold">{{ isViewByIntervenant ? 'Intervenants' : 'Bénéficiaires' }} </span>
				<i class="bi bi-chevron-down" aria-hidden="true"></i>
			</span>

			<ul
				class="dropdown-menu hand-cursor"
				aria-labelledby="dropdownViewListingType"
			>
				<li (click)="changeListingType(false)">
					<a class="dropdown-item theme-main-color">Bénéficiaires</a>
				</li>
				<li (click)="changeListingType(true)">
					<a class="dropdown-item theme-main-color">Intervenants</a>
				</li>
			</ul>
		</div>

		<!-- SÉLECTION DE DATE EN VUE JOUR UNIQUEMENT -->
		<div class="col theme-main-color d-flex" *ngIf="isViewByDay">
			<div
				class="vw-5 align-self-center text-center hand-cursor date-nav-btn rounded-pill theme-main-border-color"
				(click)="previousClick()"
			>
				<i class="bi bi-chevron-left fs-4" aria-hidden="true"></i>
			</div>
			<div
				class="vw-15 text-center mt-2 hand-cursor date-nav-btn rounded-pill theme-main-border-color"
				(click)="resetClick()"
			>
				<span
					>{{
						daysFr[dateOfStart?.getDay()] +
							' ' +
							dateOfStart?.getDate() +
							' ' +
							monthsFr[dateOfStart?.getMonth()]
					}}
				</span>
			</div>

			<div
				class="vw-5 align-self-center text-center hand-cursor date-nav-btn rounded-pill theme-main-border-color"
				(click)="nextClick()"
			>
				<i class="bi bi-chevron-right fs-4" aria-hidden="true"></i>
			</div>
		</div>

		<!-- CHAMP DE RECHERCHE EMPLOYÉ/BÉNÉFICIAIRE-->
		<div class="col-4" *ngIf="!isViewByDay">
			<div
				class="input-group"
				title="Saisir un ou plusieurs nom(s) de bénéficiaires, employés..."
			>
				<span
					class="input-group-text unselectable-text"
					id="identitySearchLabel"
					>Rechercher</span
				>
				<input
					class="form-control"
					type="text"
					placeholder="Saisir un ou plusieurs nom(s) de bénéficiaires, intervenant..."
					aria-label="searchedText"
					aria-describedby="identitySearchLabel"
					[(ngModel)]="searchedText"
				/>
			</div>
		</div>
	</div>

	<!-- ZONE D'AFFICHAGE DU PLANNING -->
	<div class="mt-4">
		<ng-container *ngIf="isViewByDay; else listWeekView">
			<div class="row">
				<div
					id="main"
					echarts
					[options]="option"
					class="min-vh-75"
					tabindex="-1"
					(chartClick)="onChartEvent($event)"
				></div>
			</div>
		</ng-container>
		<ng-template #listWeekView>
			<app-list-planning-week
				[solution]="solution"
				[startDate]="dateOfStart"
				[appliedFilter]="searchedText"
				[isViewByIntervenant]="isViewByIntervenant"
				(openEventModalEmitter)="openEventModal($event)"
			></app-list-planning-week>
		</ng-template>
	</div>
</div>

<div class="row" *ngIf="!(solution && solution.plannings && dateOfStart)">
	<app-no-data-available></app-no-data-available>
</div>
